import { Directive } from '@angular/core';

@Directive({
  selector: '[blazeSlotMarker]',
  standalone: false,
})
export class SlotMarkerDirective {}
